import { emitter } from "@/utils/emitter"
import GlobalAudioPlayer from "@/components/media/audioPlayer/GlobalAudioPlayer.js"
import { isDev } from "@/utils/tools.js"
export const jsBridge = async (method, ...args) => {
  if (method === "view.login" || method === "music.login") {
    emitter.emit("before:appLogin")
  }
  if (["music.login", "view.open"].includes(method)) {
    GlobalAudioPlayer.pause(GlobalAudioPlayer.currentUrl)
  }
  if (["track.logEvent"].includes(method)) {
    let obj = args[0]?.info ? JSON.parse(args[0].info) : {}
    obj.dev = isDev()
    obj.href = window.location.href
    args[0].info = JSON.stringify(obj)
    console.log("埋点执行", method, ...args)
    return window.flutter_inappwebview?.callHandler?.(method, ...args)
  }
  console.log("jsBridge执行", method, ...args)
  return window.flutter_inappwebview?.callHandler?.(method, ...args)
}

jsBridge.inTiangongApp = true

Object.defineProperty(jsBridge, "inTiangongApp", {
  get() {
    return window.flutter_inappwebview?.callHandler !== undefined
  },
})
